module.exports = __webpack_public_path__ + "img/375.f75d7097.jpg";